import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import APIPoliciesDemo from './api-policies';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <APIPoliciesDemo />
  </React.StrictMode>
);
